import { AgDialog } from '@australiangreens/ag-internal-components';
import { Typography } from '@mui/material';

export type UpdateOrSaveAsNewSearchTemplateDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  openSaveSearchTemplateDialog: (toOpen: boolean) => void;
  openUpdateSearchTemplateDialog: (toOpen: boolean) => void;
};

export default function UpdateOrSaveAsNewSearchTemplateDialog({
  isOpen,
  onClose,
  openSaveSearchTemplateDialog,
  openUpdateSearchTemplateDialog,
}: UpdateOrSaveAsNewSearchTemplateDialogProps) {
  return (
    <AgDialog
      isOpen={isOpen}
      onClose={() => onClose()}
      dialogTitle="Update or save as new?"
      primaryButton={{
        text: 'Save new',
        onClick: async () => {
          openSaveSearchTemplateDialog(true);
          onClose();
        },
      }}
      additionalButtons={[
        {
          text: 'Update',
          onClick: async () => {
            openUpdateSearchTemplateDialog(true);
            onClose();
          },
        },
      ]}
      secondaryButton={{ text: 'Cancel', onClick: async () => onClose() }}
      data-testid="UpdateOrSaveAsNewSearchTemplateDialog"
    >
      <Typography>
        You have made changes to an existing search template. Do you want to update the existing
        template or save a new template?
      </Typography>
    </AgDialog>
  );
}
